import { useItemHandleFragment$data } from './__generated__/useItemHandleFragment.graphql';

export const useItemLabel = (item: useItemHandleFragment$data) => {
  if (item.label) {
    return item.label;
  }

  if (Array.isArray(item.pins) && item.pins.length > 0) {
    return item.pins[0].label;
  }

  return undefined;
};
